import { z } from "zod";

export const PRIVACY_POLICY_VERSION = "2026-10-12";
export const SIGNUP_CONSENT_DRAFT = "novari:signup-consent-intent";
export const signupConsentFields = {
  birth_month: z.number().int().min(1).max(12),
  birth_year: z.number().int().min(1900).max(9999),
  privacy_accepted: z.literal(true, {
    errorMap: () => ({
      message: "Please tick the privacy-policy agreement before continuing.",
    }),
  }),
  policy_version: z.literal(PRIVACY_POLICY_VERSION),
};
export function birthDateError(
  month: number,
  year: number,
  now = new Date(),
): string | null {
  if (
    !Number.isInteger(month) ||
    month < 1 ||
    month > 12 ||
    !Number.isInteger(year) ||
    year < 1900
  )
    return "Choose your birth month and enter a valid birth year.";
  const currentMonth = now.getUTCFullYear() * 12 + now.getUTCMonth();
  if (year * 12 + month - 1 > currentMonth)
    return "Your birth month and year cannot be in the future.";
  // Without a birth day, use the last day of the birth month so a child is
  // never treated as 13 before their possible birthday. SQL uses the same rule.
  const latestBirthday = new Date(Date.UTC(year + 13, month, 0));
  if (
    latestBirthday.getTime() >
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  )
    return "You cannot create an independent account yet. Please ask a parent or guardian to help you use Novari. If you turn 13 this month, try again next month.";
  return null;
}
export function refineSignupBirth(
  data: { birth_month: number; birth_year: number },
  ctx: z.RefinementCtx,
) {
  const error = birthDateError(data.birth_month, data.birth_year);
  if (error)
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["birth_year"],
      message: error,
    });
}
export const signupConsentSchema = z
  .object(signupConsentFields)
  .superRefine(refineSignupBirth);
export type SignupConsent = z.infer<typeof signupConsentSchema>;
